export type Direction = 'up' | 'down' | 'left' | 'right';

export interface Cell {
  row: number;
  col: number;
}

export interface MazePiece {
  id: number;
  headCell: Cell;      
  cells: Cell[];        
  direction: Direction; 
  active: boolean;
}

export interface LevelConfig {
  level: number;
  rows: number;
  cols: number;
  maxPieceLen: number; 
}

export const LEVEL_CONFIGS: LevelConfig[] = [
  { level: 1, rows: 10, cols: 10, maxPieceLen: 4 },
  { level: 2, rows: 12, cols: 12, maxPieceLen: 5 },
  { level: 3, rows: 13, cols: 13, maxPieceLen: 5 },
  { level: 4, rows: 14, cols: 14, maxPieceLen: 6 },
  { level: 5, rows: 15, cols: 15, maxPieceLen: 7 },
  { level: 6, rows: 16, cols: 16, maxPieceLen: 8 },
  { level: 7, rows: 17, cols: 17, maxPieceLen: 10 },
  { level: 8, rows: 18, cols: 18, maxPieceLen: 12 },
  { level: 9, rows: 24, cols: 24, maxPieceLen: 25 },
];